import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';



const persistConfig = {
    key: 'root',
    storage,
    timeout: null,
}


export default persistReducer(persistConfig, appReducer)

function appReducer(state, action) {
    switch (action.type) {
        case "SETSTATE":
            if (action.payload === undefined) {
                return undefined
            }
            return action.payload
        case "USER":         
            return {
                ...state,
                userData: action.payload
            };
        case "USERFULLDATA":
            return {
                ...state,
                userFullData: action.payload
            };
        case "ACTIONWINDOWPOPUP":
            return {
                ...state,
                windowpopup: action.payload
            };
        case "ACTIONTA":
            return {
                ...state,
                taaction: action.payload
            };
        case "ROLE":
            return {
                ...state,
                roleData: action.payload
            };
       
        case "TASKNAME":
            return {
                ...state,
                taskDataName: action.payload
            };
        case "TASKID":
            return {
                ...state,
                taskDataId: action.payload
            };
        case "ROLEID":
            return {
                ...state,
                roleDataId: action.payload
            };
        case "ROLENAME":
            return {
                ...state,
                roleDataName: action.payload
            };
        case "USERNAME":
            return {
                ...state,
                userDataName: action.payload
            };
        case "FOLDERNAME":
            return {
                ...state,
                folderDataName: action.payload
            };
        case "FOLDERVIEWKEY":
            return {
                ...state,
                folderDataViewKey: action.payload
            };
        case "DIRECTORYID":
            return {
                ...state,
                directoryDataId: action.payload
            };
        case "FOLDERID":
            return {
                ...state,
                folderDataId: action.payload
            };
        case "DIRECTORYNAME":
            return {
                ...state,
                directoryDataName: action.payload
            };
        case "CONTEXTTEMPLATEID":
            return {
                ...state,
                contextTemplateDataId: action.payload
            };       
        case "CONTEXTSELECTION":
            return {
                ...state,
                contextSelection: action.payload
            };  
        case "CONTEXTIDSELECTION":
            return {
                ...state,
                contextIdSelection: action.payload
            }; 
        case "OBJECTID":
            return {
                ...state,
                currentObjectID: action.payload
            };
        case "ALLOBJECT":
            return {
                ...state,
                currentObject: action.payload
            };
        case "THEMENAME":
            return {
                ...state,
                currentThemeName: action.payload
            };
        case "CONTEXTCONFIGURATION":
            return {
                ...state,
                currentContextConfiguration: action.payload
            };
        case "ACTIONMESSAGE":
            return {
                ...state,
                currentActionmessage: action.payload
            };
        case "ACTIONMULTIROOT":
            return {
                ...state,
                currentActionmultiroot: action.payload
            };
        case "NOTIFICATIONSTASKS":
            return {
                ...state,
                currentNotificationsTasks: action.payload
            };
        case "NOTIFICATIONSFOLDER":
            return {
                ...state,
                currentNotificationsFolders: action.payload
            };
        case "NOTIFICATIONSCOUNT":
            return {
                ...state,
                currNotificationsCount: action.payload
            };
        case "NOTIFICATIONS":
            return {
                ...state,
                currNotifications: action.payload
            };
        case "ACTIONFOOTER":
            return {
                ...state,
                currFooterState: action.payload
            };
        case "ACTIONDASHBOARDLIST":
            return {
                ...state,
                currDashboardlistState: action.payload
            };
        case "ACTIONREFRESHDASHBOARD":
            return {
                ...state,
                currRefreshDashboardState: action.payload
            };
        case "ACTIONID":
            return {
                ...state,
                currActionIdState: action.payload
            };
        case "ACTIONURL":
            return {
                ...state,
                currActionUrlState: action.payload
            };
            
        case "DEFAULTROLEID":
            return {
                ...state,
                currDefaultRoleIDState: action.payload
            };
        case "ACTIONTASKNOTIFICATION":
            return {
                ...state,
                currTaskNotificationState: action.payload
            };
        case "ACTIONFOLDERNOTIFICATION":
            return {
                ...state,
                currFolderNotificationState: action.payload
            };
        case "ACTIONLEFTSIDEBAR":
            return {
                ...state,
                currFolderExpandCollapse: action.payload
            };
        case "ACTIONRIGHTSIDEBAR":
            return {
                ...state,
                currTaskContextExpandCollapse: action.payload
            };
        case "ACTIONCONTEXTCOLLPASEEXPAND":
            return {
                ...state,
                currContextExpandCollapse: action.payload
            };
        case "ACTIONCACHE":
            return {
                ...state,
                currCacheState: action.payload
            };
        case "DROPDOWNFLAG":
            return {
                ...state,
                currDropdownflagState: action.payload
            };
        case "RootContextID":
            return {
                ...state,
                rootContext: action.payload
            };
        case "ISROOTESELECTED":
            return {
                ...state,
                rootSelected: action.payload
            };
        case "ACTIONTABS":
            return {
                ...state,
                currTabsState: action.payload
            };
        case "ACTIONSLOCAL":
            return {
                ...state,
                currActionsLocal: action.payload
            };
        case "ACTIONAME":
            return {
                ...state,
                currActionsName: action.payload
            };
            
        //case "ACTIONTABREMOVE":
        //    return {
        //        ...state,
        //        currTabRemove: action.payload
        //    };
        default:
            return state; 
    }
};


// WEBPACK FOOTER //
// ./src/reducers/appReducer.js